/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planshare_Import_TitleInputs */

const en_us2_planshare_import_title = /** @type {(inputs: Planshare_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Got a code?`)
};

const pt_br2_planshare_import_title = /** @type {(inputs: Planshare_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recebeu um código?`)
};

const pt_pt2_planshare_import_title = /** @type {(inputs: Planshare_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recebeu um código?`)
};

/** @type {(inputs: Planshare_Import_TitleInputs) => LocalizedString} */
const es_419_planshare_import_title = en_us2_planshare_import_title;

/** @type {(inputs: Planshare_Import_TitleInputs) => LocalizedString} */
const fr_fr2_planshare_import_title = en_us2_planshare_import_title;

/** @type {(inputs: Planshare_Import_TitleInputs) => LocalizedString} */
const de_de2_planshare_import_title = en_us2_planshare_import_title;

/** @type {(inputs: Planshare_Import_TitleInputs) => LocalizedString} */
const it_it2_planshare_import_title = en_us2_planshare_import_title;

/**
* | output |
* | --- |
* | "Got a code?" |
*
* @param {Planshare_Import_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const planshare_import_title = /** @type {((inputs?: Planshare_Import_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planshare_Import_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_planshare_import_title(inputs)
	if (locale === "es-419") return es_419_planshare_import_title(inputs)
	if (locale === "pt-PT") return pt_pt2_planshare_import_title(inputs)
	if (locale === "fr-FR") return fr_fr2_planshare_import_title(inputs)
	if (locale === "de-DE") return de_de2_planshare_import_title(inputs)
	if (locale === "it-IT") return it_it2_planshare_import_title(inputs)
	return en_us2_planshare_import_title(inputs)
});
export { planshare_import_title as "planshare.import_title" }